<section class="quote-progress" aria-label="Selected quote">
  <h5 class="quote-progress__heading" data-testid="selected-quote-heading">
    {{ heading() }}
  </h5>
  <div class="quote-progress__vendor-header">
    <span class="quote-progress__vendor">{{ vendorName() }}</span>
    <button
      type="button"
      class="quote-progress__download"
      aria-label="View Quote PDF"
      (click)="generateQuotePDF()"
    >
      View Quote PDF
    </button>
  </div>

  @if (hasAnyReclassification()) {
    <div
      class="quote-progress__reclassification-banner"
      role="alert"
      data-testid="job-requirement-change-banner"
    >
      <mat-icon class="quote-progress__banner-icon" aria-hidden="true"
        >info</mat-icon
      >
      <p class="quote-progress__banner-text">
        <strong>Job Requirement Change:</strong> While reviewing your files for
        translation, the vendor identified some changes regarding Desktop
        Publishing needs. If you select this quote, these changes will be
        reflected in the Job Details tab. For more details please expand the
        Document Requirement Changes accordion.
      </p>
    </div>
  }

  <app-quote-cost-card
    [deliveryType]="deliveryType()"
    [deliveryDate]="deliveryDate()"
    [quoteId]="quoteId()"
    [currency]="currency()"
    [costBreakdown]="costBreakdown()"
    [totalCost]="totalCost()"
    [recommendedPOTotal]="recommendedPOTotal()"
    [costDeltas]="costDeltas()"
  />

  <!-- Purchase Order -->
  <span class="quote-progress__purchase-order">
    <span class="quote-progress__purchase-order-label">Purchase Order:</span>
    <span class="quote-progress__purchase-order-value">{{
      purchaseOrderId()
    }}</span>
  </span>

  <app-document-requirement-changes [detail]="vendorJobDetails()" />

  <app-previous-quotes
    [estimates]="approvedPreviousEstimates()"
    [order]="order()"
    [selectedEstimate]="vendorEstimate()"
    [lowestCostId]="lowestCostId()"
    [showTopBorder]="showPreviousQuotesTopBorder()"
  />
</section>
